import React, { useState, ReactElement, useEffect, memo } from 'react';
import { resolvePath } from '@/utils/resolvePath';
import BackArrow from 'Assets/Icons/left-arrow-v2.svg';
import useCustomBack from '../../hooks/useCustomBack';
import HelpCall from 'Assets/Icons/help-call.svg';
import BookingFlowTimeline from 'Components/common/timeline/bookingTimeline';
import { useRouter } from 'next/router';
import { useWebviewCallback } from 'Utils/webviewHandlers';
import { EWebViewActions } from 'Types/index';
import { PageRoutes } from '@/constants/trackingStages';
import useGarageDetails from '../../hooks/useGarageDetails';
import LeavingSoonModal from '../leavingSoonModal';
import CarIcon from '@/assets/Icons/car-header.svg';
import {
    GARAGE_URL_MAPPING,
    PATHS_WITH_CAR_EDIT_ICON,
    ROUTEMAP,
} from '../../constants';
import Router from '@/components/common/router';

import Cookies from 'js-cookie';
import { selectVehicleInfo } from '@/store/modules/savedVehicleSlice';
import { useSelector } from 'react-redux';
import { EditSavedAsset } from '../vehicleAssetWrapper';
import { TAP_BTN_ADSC_HELP, TAP_BTN_ASSET_ICON } from '@/analytics/events';
import { trackEventAPI } from '@/analytics/middleware';
import { getMMVDetails } from '../../utils';
import ArrowIcon from '@/components/common/arrowIcon';
import { redirectToLandingPage } from '@/utils/common';

interface IHeaderProps {
    showHelp?: boolean;
    close?: boolean;
    title?: ReactElement;
    hideLocation?: boolean;
    showOnlyBackCTA?: boolean;
    changeCar?: () => void;
    backURL?: string | undefined;
    color?: string | undefined;
    isFreeServiceEligible?: boolean;
}

const GarageHeader = (props: IHeaderProps) => {
    const { hasSavedVehicle = false, vehicleDetails } =
        useSelector(selectVehicleInfo);
    console.log('change vehicle details', vehicleDetails?.model);
    const router = useRouter();
    const { garageId, garageName } = useGarageDetails();
    const isWebView = Boolean(Cookies.get('webview'));

    console.log('rendering', { garageName, garageId });
    const {
        showHelp = false,
        close = false,
        hideLocation = false,
        title,
        showOnlyBackCTA = false,
        changeCar,
        backURL,
        color = '#121212',
        isFreeServiceEligible,
    } = props;
    const { closeWebView } = useCustomBack(close, backURL);
    const [leavingSoonModal, setleavingSoonModal] = useState(false);
    const isPickDropPage = router.pathname === ROUTEMAP.GARAGE_PICK_DROP;

    const showCarEditModalOnFirstMount =
        router.pathname === ROUTEMAP.GARAGE_PICK_DROP ||
        router.pathname === ROUTEMAP.GARAGE_SPECIFIC_REPAIR;
    const showCarEditIcon =
        PATHS_WITH_CAR_EDIT_ICON.includes(router.pathname) &&
        !isFreeServiceEligible;
    function handleBackClick() {
        // if (isPickDropPage) {
        //     setleavingSoonModal(true);
        // } else {
        if (close && backURL === '/homepage') {
            redirectToLandingPage();
        } else if (close && isWebView) {
            closeWebView();
        } else if (close && backURL) {
            Router.push(backURL);
        } else {
            router.back();
        }
        // }
    }
    function handleHelpClick() {
        trackEventAPI({
            event_name: TAP_BTN_ADSC_HELP,
            customAttributes: {
                ...getMMVDetails(),
                adsc_price_seen:
                    localStorage.getItem('price-seen') === 'true'
                        ? true
                        : false,
                adsc_page_url: router?.pathname,
            },
            isFakeDoor: true,
        });

        Router.push(ROUTEMAP.GARAGE_HELP_PAGE);
    }
    const locationIconPath =
        color === 'white'
            ? '/images/location-icon-white.svg'
            : '/images/location-pin.svg';
    return (
        <div>
            <div className="header">
                {/* <BackArrow onClick={handleBackClick} /> */}
                <ArrowIcon
                    direction="left"
                    size={24}
                    color={color}
                    clickHandler={handleBackClick}
                />

                {!showOnlyBackCTA && (
                    <div className="header-menu">
                        {!hideLocation && garageName && (
                            <div className="location">
                                <img
                                    src={resolvePath(locationIconPath)}
                                    alt="location"
                                    className="service-icon"
                                />
                                <div className="garage-name">{garageName}</div>
                            </div>
                        )}

                        {/* {!showHelp && (
                            <img
                                src={resolvePath('/images/avatar.svg')}
                                alt="profile"
                            />
                        )} */}
                        {showCarEditIcon && hasSavedVehicle && (
                            // <div className="car" onClick={changeCar}>
                            //     <CarIcon />
                            //     {vehicleDetails?.model}
                            // </div>
                            <EditSavedAsset
                                carModel={vehicleDetails?.model || ''}
                                color={color}
                                showCarEditModalOnFirstMount={
                                    showCarEditModalOnFirstMount
                                }
                            />
                        )}
                        {showHelp && (
                            <div className="help-cta" onClick={handleHelpClick}>
                                <HelpCall />
                                <span>Help</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <LeavingSoonModal
                show={leavingSoonModal}
                isMobile={true}
                closeModal={() => setleavingSoonModal(false)}
            />
            {title && <div className="title">{title}</div>}
            <style jsx>{`
                .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 16px 0;
                    animation: slideDown 0.3s ease-out;
                }
                .header-menu {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    z-index: 99;
                }
                .location {
                    display: flex;
                }
                .garage-name {
                    font-size: 12px;
                    font-weight: 400;
                    color: ${color};
                    margin: 0 4px 0 4px;
                }
                .help-cta {
                    display: flex;
                    align-items: center;
                    height: 25px;
                    width: max-content;
                    border: 1px solid #040222;
                    border-radius: 4px;
                    padding: 0 8px;
                    font-weight: 600;
                    font-size: 12px;
                    line-height: 16px;
                    margin: 0 4px 0 4px;

                    cursor: pointer;

                    & > span {
                        margin: 0 0 0 6px;
                    }
                }
                .car {
                    display: flex;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 400;
                    color: #121212;
                    align-items: center;
                    margin: 0 4px 0 4px;
                    gap: 2px;
                }
                .title {
                    color: #121212;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 28px;
                    letter-spacing: -0.1px;
                    & > span {
                        color: #7c47e1 !important;
                    }
                    margin-bottom: 20px;
                }
                .title > span {
                    color: #7c47e1 !important;
                }
                @keyframes slideDown {
                    from {
                        transform: translateY(-1rem);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

function areEqual(prevProps: IHeaderProps, nextProps: IHeaderProps) {
    console.log('prev', prevProps, nextProps);
    return (
        prevProps.showHelp === nextProps.showHelp &&
        prevProps.close === nextProps.close &&
        prevProps.showOnlyBackCTA === nextProps.showOnlyBackCTA &&
        prevProps.hideLocation === nextProps.hideLocation &&
        prevProps.backURL === nextProps.backURL &&
        prevProps.color === nextProps.color &&
        React.isValidElement(prevProps.title) ===
            React.isValidElement(nextProps.title) &&
        prevProps.title?.props === nextProps.title?.props &&
        prevProps.changeCar === nextProps.changeCar
    );
}

export default memo(GarageHeader, areEqual);

export const useVehicleInfoCheck = (): boolean => {
    const [isVehicleInfoComplete, setIsVehicleInfoComplete] =
        useState<boolean>(false);

    useEffect(() => {
        const mmv = localStorage.getItem('mmv');
        const registrationNumber = localStorage.getItem('registration_number');

        setIsVehicleInfoComplete(!!mmv && !!registrationNumber);
    }, []);

    return isVehicleInfoComplete;
};
